module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 013.95ddbcd6.jpg";